// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__37aQs","radioRow":"SimpleQuestionBuilderModal_radioRow__35Yhs"};